import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupFinanceByTrialGroupId: ITrialGroupFinanceLoadByTrialGroupIdActionCreator = (trialGroupId) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_LOAD_BY_TRIAL_GROUP_ID,
            trialGroupId
        }
    },
    LoadTrialGroupFinanceById: ITrialGroupFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialGroupFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupFinance: ITrialGroupFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupFinance: ITrialGroupFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupFinance: ITrialGroupFinanceCreateActionCreator = (trialGroupId) => {

        return {
            type: ACTION_TRIALGROUPFINANCE_CREATE,
            trialGroupId
        }
    },
    CreateSuccess: ITrialGroupFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialGroupFinance: ITrialGroupFinanceSyncActionCreator = (trialGroupId) => {

        return {
            type: ACTION_TRIALGROUPFINANCE_SYNC,
            trialGroupId
        }
    },
    SyncSuccess: ITrialGroupFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialGroupFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPFINANCE_LOAD_BY_TRIAL_GROUP_ID = "ACTION_TRIALGROUPFINANCE_LOAD_BY_TRIAL_GROUP_ID",
    ACTION_TRIALGROUPFINANCE_LOAD_BY_ID = "ACTION_TRIALGROUPFINANCE_LOAD_BY_ID",
    ACTION_TRIALGROUPFINANCE_LOAD_SUCCESS = "ACTION_TRIALGROUPFINANCE_LOAD_SUCCESS",
    ACTION_TRIALGROUPFINANCE_LOAD_FAILURE = "ACTION_TRIALGROUPFINANCE_LOAD_FAILURE",

    ACTION_TRIALGROUPFINANCE_SAVE = "ACTION_TRIALGROUPFINANCE_SAVE",
    ACTION_TRIALGROUPFINANCE_SAVE_SUCCESS = "ACTION_TRIALGROUPFINANCE_SAVE_SUCCESS",
    ACTION_TRIALGROUPFINANCE_SAVE_FAILURE = "ACTION_TRIALGROUPFINANCE_SAVE_FAILURE",

    ACTION_TRIALGROUPFINANCE_VALIDATE = "ACTION_TRIALGROUPFINANCE_VALIDATE",
    ACTION_TRIALGROUPFINANCE_VALIDATE_SUCCESS = "ACTION_TRIALGROUPFINANCE_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPFINANCE_VALIDATE_FAILURE = "ACTION_TRIALGROUPFINANCE_VALIDATE_FAILURE",

    ACTION_TRIALGROUPFINANCE_CREATE = "ACTION_TRIALGROUPFINANCE_CREATE",
    ACTION_TRIALGROUPFINANCE_CREATE_SUCCESS = "ACTION_TRIALGROUPFINANCE_CREATE_SUCCESS",
    ACTION_TRIALGROUPFINANCE_CREATE_FAILURE = "ACTION_TRIALGROUPFINANCE_CREATE_FAILURE",

    ACTION_TRIALGROUPFINANCE_SYNC = "ACTION_TRIALGROUPFINANCE_SYNC",
    ACTION_TRIALGROUPFINANCE_SYNC_SUCCESS = "ACTION_TRIALGROUPFINANCE_SYNC_SUCCESS",
    ACTION_TRIALGROUPFINANCE_SYNC_FAILURE = "ACTION_TRIALGROUPFINANCE_SYNC_FAILURE",

    ACTION_TRIALGROUPFINANCE_CLEAR = "ACTION_TRIALGROUPFINANCE_CLEAR",

    ACTION_TRIALGROUPFINANCE_FILTER = "ACTION_TRIALGROUPFINANCE_FILTER";

export interface ITrialGroupFinanceLoadByTrialGroupIdAction {
    type: "ACTION_TRIALGROUPFINANCE_LOAD_BY_TRIAL_GROUP_ID";
    trialGroupId: number;
}

export interface ITrialGroupFinanceLoadByTrialGroupIdActionCreator {
    (trialGroupId: number): ITrialGroupFinanceLoadByTrialGroupIdAction;
}

export interface ITrialGroupFinanceLoadSuccessAction {
    type: "ACTION_TRIALGROUPFINANCE_LOAD_SUCCESS";
    formData: Dtos.TrialGroupFinance | Dtos.TrialGroupFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupFinance | Dtos.TrialGroupFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupFinanceLoadSuccessAction;
}

export interface ITrialGroupFinanceLoadFailureAction {
    type: "ACTION_TRIALGROUPFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupFinanceLoadFailureAction;
}

export interface ITrialGroupFinanceLoadByIdAction {
    type: "ACTION_TRIALGROUPFINANCE_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupFinanceLoadByIdActionCreator {
    (id: number): ITrialGroupFinanceLoadByIdAction;
}

export interface ITrialGroupFinanceSaveAction {
    type: "ACTION_TRIALGROUPFINANCE_SAVE";
    formData: Dtos.TrialGroupFinance;

}

export interface ITrialGroupFinanceSaveActionCreator {
    (
        formData: Dtos.TrialGroupFinance
    ): ITrialGroupFinanceSaveAction;
}

export interface ITrialGroupFinanceSaveSuccessAction {
    type: "ACTION_TRIALGROUPFINANCE_SAVE_SUCCESS";
    formData: Dtos.TrialGroupFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupFinanceSaveSuccessAction;
}

export interface ITrialGroupFinanceSaveFailureAction {
    type: "ACTION_TRIALGROUPFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupFinanceSaveFailureAction;
}

export interface ITrialGroupFinanceValidateAction {
    type: "ACTION_TRIALGROUPFINANCE_VALIDATE";
    formData: Dtos.TrialGroupFinance;

}

export interface ITrialGroupFinanceValidateActionCreator {
    (
        formData: Dtos.TrialGroupFinance
    ): ITrialGroupFinanceValidateAction;
}

export interface ITrialGroupFinanceValidateSuccessAction {
    type: "ACTION_TRIALGROUPFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupFinanceValidateSuccessAction;
}

export interface ITrialGroupFinanceValidateFailureAction {
    type: "ACTION_TRIALGROUPFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupFinanceValidateFailureAction;
}

export interface ITrialGroupFinanceCreateAction {
    type: "ACTION_TRIALGROUPFINANCE_CREATE",
    trialGroupId: number
}

export interface ITrialGroupFinanceCreateActionCreator {
    (trialGroupId: number): ITrialGroupFinanceCreateAction
}

export interface ITrialGroupFinanceCreateSuccessAction {
    type: "ACTION_TRIALGROUPFINANCE_CREATE_SUCCESS";
    formData: Dtos.TrialGroupFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialGroupFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupFinanceCreateSuccessAction;
}

export interface ITrialGroupFinanceCreateFailureAction {
    type: "ACTION_TRIALGROUPFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupFinanceCreateFailureAction;
}

export interface ITrialGroupFinanceClearAction {
    type: "ACTION_TRIALGROUPFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupFinanceClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupFinanceClearAction;
}

export interface ITrialGroupFinanceFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupFinanceFilterAction;
}

export interface ITrialGroupFinanceFilterAction {
    type: "ACTION_TRIALGROUPFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialGroupFinanceSyncAction {
    type: "ACTION_TRIALGROUPFINANCE_SYNC",
    trialGroupId: number
}

export interface ITrialGroupFinanceSyncActionCreator {
    (trialGroupId: number): ITrialGroupFinanceSyncAction
}

export interface ITrialGroupFinanceSyncSuccessAction {
    type: "ACTION_TRIALGROUPFINANCE_SYNC_SUCCESS";
    formData: Dtos.TrialGroupFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.TrialGroupFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupFinanceSyncSuccessAction;
}

export interface ITrialGroupFinanceSyncFailureAction {
    type: "ACTION_TRIALGROUPFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupFinanceSyncFailureAction;
}

export type TrialGroupFinanceAction =
    ITrialGroupFinanceLoadByTrialGroupIdAction |
    ITrialGroupFinanceLoadByIdAction |
    ITrialGroupFinanceLoadFailureAction |
    ITrialGroupFinanceLoadSuccessAction |
    ITrialGroupFinanceSaveAction |
    ITrialGroupFinanceSaveSuccessAction |
    ITrialGroupFinanceSaveFailureAction |
    ITrialGroupFinanceValidateAction |
    ITrialGroupFinanceValidateSuccessAction |
    ITrialGroupFinanceValidateFailureAction |
    ITrialGroupFinanceCreateAction |
    ITrialGroupFinanceCreateSuccessAction |
    ITrialGroupFinanceCreateFailureAction |
    ITrialGroupFinanceSyncAction |
    ITrialGroupFinanceSyncSuccessAction |
    ITrialGroupFinanceSyncFailureAction |
    ITrialGroupFinanceClearAction | 
    ITrialGroupFinanceFilterAction;
